(() => {
  if (!document.body.classList.contains('template-collection') ||
      document.documentElement.hasAttribute('data-hhs-collection-sort-ready')) return;

  document.documentElement.setAttribute('data-hhs-collection-sort-ready', '');
  const desktop = window.matchMedia('(min-width: 990px)');
  let frame = 0;

  const update = () => {
    frame = 0;
    document.body.classList.toggle('collection-facets-scrolled', desktop.matches && window.scrollY > 8);
  };

  const schedule = () => {
    if (!frame) frame = window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  desktop.addEventListener('change', schedule);
  update();
})();
